import Spinner from './Spinner';

export default function Loading(): JSX.Element {
  return (
    <div className="flex justify-center items-center h-screen flex-col">
      <Spinner />
    </div>
  );
}
